import { bindActionCreators } from 'redux';
import {
	Action,
	SURVEY_ANSWERED,
	SURVEY_CHANGE_STEP,
	SURVEY_PREPARE,
	SURVEY_START,
	SURVEY_UPLOAD_RESULT
} from '.';
import store from './../reducers';

export default bindActionCreators({
	answer: (id, variant, options, uid) => Action(SURVEY_ANSWERED, { id, variant, options, uid }),
	changeStep: (payload) => Action(SURVEY_CHANGE_STEP, payload),
	startSurvey: () => Action(SURVEY_START),
	prepare: () => Action(SURVEY_PREPARE),
	getResult: () => Action(SURVEY_UPLOAD_RESULT),
}, store.dispatch);




// WEBPACK FOOTER //
// ./src/actions/survey.js